module.exports = __webpack_public_path__ + "static/media/EatZilla.9483ea26.gif";